/* Postrly cart v3 — one-click adds (upsells + single-variant cards),
   in-cart variant editing, discount code apply, countdown. Adds from
   outside the drawer open the drawer after adding. */
(function () {
  'use strict';

  function refreshDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) { drawer.innerHTML = fresh.innerHTML; drawer.classList.remove('is-empty'); }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) bubble.innerHTML = sections['cart-icon-bubble'];
        if (openAfter && drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
        initCountdown();
      })
      .catch(function () {});
  }
  window.postrlyRefreshCartDrawer = refreshDrawer;

  /* One-click add (cart upsells + single-variant card buttons) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-postrly-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    var openAfter = !btn.closest('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-postrly-upsell-add'), 10), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshDrawer(openAfter); })
      .then(function () { btn.textContent = prev; btn.disabled = false; })
      .catch(function () { btn.disabled = false; btn.textContent = prev; });
  }, true);

  /* In-cart variant editing: change = add new variant + drop old line */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pcio-size], [data-pcio-frame]');
    if (!sel) return;
    var wrap = sel.closest('[data-pcio]');
    if (!wrap) return;
    var variants;
    try { variants = JSON.parse(wrap.querySelector('[data-pcio-variants]').textContent); } catch (err) { return; }
    var sizeSel = wrap.querySelector('[data-pcio-size]');
    var frameSel = wrap.querySelector('[data-pcio-frame]');
    var o1 = sizeSel ? sizeSel.value : null;
    var o2 = frameSel ? frameSel.value : null;
    var target = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].o1 === o1 && (o2 === null || variants[i].o2 === o2)) { target = variants[i]; break; }
    }
    var line = wrap.getAttribute('data-line');
    var qty = parseInt(wrap.getAttribute('data-qty'), 10) || 1;
    if (!target || !line) return;
    if (!target.available) { refreshDrawer(false); return; }
    wrap.querySelectorAll('select').forEach(function (s) { s.disabled = true; });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line, quantity: 0 })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: target.id, quantity: qty }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('re-add failed'); return r.json(); })
      .then(function () { return refreshDrawer(false); })
      .catch(function () { refreshDrawer(false); });
  });

  /* Discount code — registers the code for checkout, no fake totals */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-postrly-discount-apply]');
    if (!btn) return;
    var box = btn.closest('[data-postrly-discount]');
    var input = box && box.querySelector('[data-postrly-discount-input]');
    var note = box && box.parentElement.querySelector('[data-postrly-discount-note]');
    if (!input || !input.value.trim()) return;
    var code = input.value.trim();
    btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
      .then(function () {
        if (note) { note.hidden = false; note.textContent = 'Code “' + code + '” saved — it will apply at checkout if valid.'; }
      })
      .catch(function () {
        if (note) { note.hidden = false; note.textContent = 'Couldn’t save that code — try again at checkout.'; }
      })
      .then(function () { btn.disabled = false; });
  });

  /* Countdown timer */
  var timerId = null;
  function initCountdown() {
    var el = document.querySelector('[data-postrly-countdown]');
    if (!el) { if (timerId) { clearInterval(timerId); timerId = null; } return; }
    var end = new Date(el.getAttribute('data-end')).getTime();
    var out = el.querySelector('[data-countdown-out]');
    if (!out || isNaN(end)) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var el2 = document.querySelector('[data-postrly-countdown]');
      if (!el2) { clearInterval(timerId); timerId = null; return; }
      var out2 = el2.querySelector('[data-countdown-out]');
      var d = end - Date.now();
      if (d <= 0) {
        var expired = el2.getAttribute('data-expired') || '';
        if (expired) { el2.innerHTML = '<span>' + expired + '</span>'; }
        else { el2.style.display = 'none'; }
        clearInterval(timerId); timerId = null; return;
      }
      var t = Math.floor(d / 1000);
      var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
      if (out2) out2.textContent = (h > 23 ? Math.floor(h / 24) + 'd ' : '') + pad(h % 24) + ':' + pad(m) + ':' + pad(s);
    }
    if (timerId) clearInterval(timerId);
    tick();
    timerId = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCountdown);
  else initCountdown();
})();
